'use client';

import React from 'react';
import { Bookmark, Target, Zap, Trophy } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const KPIS = [
  {
    id: 'kpi-saved',
    icon: Bookmark,
    label: 'Segments Saved',
    value: '7',
    sub: '2 added this week',
    trend: 'up',
    color: 'text-[hsl(var(--primary))]',
    bg: 'bg-[hsl(var(--primary)/0.06)]',
  },
  {
    id: 'kpi-avgprob',
    icon: Target,
    label: 'Avg Win Probability',
    value: '74%',
    sub: '+3% vs last week',
    trend: 'up',
    color: 'text-green-600',
    bg: 'bg-green-50',
  },
  {
    id: 'kpi-gap',
    icon: Zap,
    label: 'Closest Gap to KOM',
    value: '2s',
    sub: 'Canyon Blvd Sprint',
    trend: 'neutral',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
  {
    id: 'kpi-won',
    icon: Trophy,
    label: 'KOMs Won',
    value: '3',
    sub: 'All time from targets',
    trend: 'up',
    color: 'text-amber-500',
    bg: 'bg-amber-50',
  },
];

export default function TargetsKPIRow() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      {KPIS?.map((kpi) => {
        const Icon = kpi?.icon;
        return (
          <div key={kpi?.id} className="bg-white rounded-2xl border border-[hsl(var(--border))] p-5">
            <div className="flex items-start justify-between mb-3">
              <div className={`w-9 h-9 rounded-xl ${kpi?.bg} flex items-center justify-center`}>
                <Icon size={16} className={kpi?.color} />
              </div>
            </div>
            <p className="text-2xl font-extrabold text-[hsl(var(--foreground))] font-mono tabular-nums leading-none mb-1">
              {kpi?.value}
            </p>
            <p className="text-[11px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider mb-1">
              {kpi?.label}
            </p>
            <p className="text-[11px] text-[hsl(var(--muted-foreground))]">{kpi?.sub}</p>
          </div>
        );
      })}
    </div>
  );
}